import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Login from '../components/Login'
import Signup from '../components/signup.vue'
import KnowYou from '../components/KnowYou'
import KnowMore from '../components/KnowMore'
import Result from '../components/Result'
import ResultNew from '../components/ResultNew'
import store from '../store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/Home',
      name: 'Home',
      meta: {
        requireAuth: true // 该路由需要登录
      },
      component: Home
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/SignUp',
    //   name: 'SignUp',
    //   component: Signup
    // },
    {
      path: '/KnowYou',
      name: 'KnowYou',
      meta: {
        requireAuth: true // 该路由需要登录
      },
      component: KnowYou
    },
    {
      path: '/KnowMore',
      name: 'KnowMore',
      meta: {
        requireAuth: true // 该路由需要登录
      },
      component: KnowMore
    },
    // {
    //   path: '/Result',
    //   name: 'Result',
    //   // meta: {
    //   //   requireAuth: true // 该路由需要登录
    //   // },
    //   component: Result
    // },
    {
      path: '/ResultNew',
      name: 'ResultNew',
      meta: {
        requireAuth: true // 该路由需要登录
      },
      component: ResultNew
    }
  ]
})

//to表示目标路由 from从什么地方来的路由、对象
//next 进行下一个路由 需要放行
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (store.state.token || localStorage.getItem('token')) {
      // 通过vuex state获取当前的token是否存在    注意token有时效性
      next() //存在就说明登录了，放行
    } else {
      next({
        //不存在，回退到一个页面，例如登录页面
        path: '/',
        // query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js